export const ExpenseTypeNone: { id: number; viewValue: string } = { id: 0, viewValue: '' };

export enum ExpenseTypeEnum {
    Meal = 1,
    Mileage = 2,
    Tolls = 3,
    Lodging = 4,
    Flight = 5,
    AirlineFee = 6,
    Baggage = 7,
    TaxiRideshare = 8,
    PublicTransit = 9,
    PrivateCarTransfer = 10,
    RentalCar = 11,
    RentalCarGas = 12,
    Rail = 13,
    Internet = 14,
    Medication = 15,
    Entertainment = 16,
    Translations = 17,
    ChildCare = 18,
    Parking = 19,
    Visa = 20,
    Other = 21,
}
